import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { portalActions } from '../../../store';
import { selectLanguage } from '../../../store/languageSlice';
import {
  getReportTypeDropdown,
  getRequestedReport,
  getVistTypeDropdown,
} from '../../../utilFunctions/reports/request-report';

import { userProfileDetailReq } from '../../../utilFunctions/profile/EditProfile';

import useFetchData from '../../../utilFunctions/useFetchData';
import Loader from '../../UI/Loader';
import './style.css';

export default function RequestReport() {
  const dispatch = useDispatch();
  const { t, isRtl } = useSelector(selectLanguage);
  const PHONE_CODE = '+966';

  const { data: visitsTypeList } = useFetchData(getVistTypeDropdown);

  const {
    data: reportTypeList,
    loading: reportTypeLoading,
    error: reportTypeError,
    refetch: refetchReportTypes,
  } = useFetchData(getReportTypeDropdown);

  const {
    data: profileData,
    loading: profileLoading,
    error: profileError,
    refetch: refetchProfile,
  } = useFetchData(userProfileDetailReq);

  // Validation states
  const [messageRequire, setMessageRequire] = useState(false);
  const [reportTypeRequire, setReportTypeRequire] = useState(false);
  const [visitTypeRequire, setVisitTypeRequire] = useState(false);
  const [phoneRequire, setPhoneRequire] = useState(false);

  const [loading1, setLoading1] = useState(false);
  const [message1, setMessage1] = useState();
  const [error1, setError1] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    reportType: '',
    visitType: '',
    deliveryMethod: 'email',
    message: '',
  });

  const isVerified =
  profileData?.patientProfile?.isEmailVerified === '1';

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'message' && value.length > 500) {
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear validation errors when user enters/selects a value
    if(name === 'phone' && value.trim().length === 9){
      setPhoneRequire(false);
    }

    if (name === 'message' && value.trim() !== '') {
      setMessageRequire(false);
    }

    if (name === 'reportType' && value !== '') {
      setReportTypeRequire(false);
    }

    if (name === 'visitType' && value !== '') {
      setVisitTypeRequire(false);
    }
  };

  const handleRequestReport = async (event) => {
    event.preventDefault();

    // Validate required fields
    const isMessageEmpty = formData.message.trim() === '';
    const isReportTypeEmpty = formData.reportType === '';
    const isVisitTypeEmpty = formData.visitType === '';
    const contactNumber = formData.phone;
    const isCellNumberValid = !contactNumber || !contactNumber.trim() || contactNumber.trim().length !== 9;

    // Set validation messages
    setPhoneRequire(isCellNumberValid);
    setMessageRequire(isMessageEmpty);
    setReportTypeRequire(isReportTypeEmpty);
    setVisitTypeRequire(isVisitTypeEmpty);

    // Stop submission if any required field is empty
    if (isMessageEmpty || isReportTypeEmpty || isVisitTypeEmpty || isCellNumberValid) {
      return;
    }

    const visitType = visitsTypeList?.episode_list?.find(
      (x) => x.episode_id == formData.visitType
    );

    if (visitType) {
      const newPayload = {
        subject: 'Request Report',
        appointmentDate: visitType.episode_date,
        outPatient: `${visitType?.episodeType}-${visitType?.care_provider_description}`,
        message: formData.message,
        pickupId: '',
        pickupDob: '',
        episodeNo: visitType?.episode_number,
        episode: visitType.episode_id,
        episodeKey: '',
        hosp: 1,
        copyType: formData.deliveryMethod,
        pickupName: '',
        mrNumber: '',
        email: formData.email,
        patientId: '',
        reportType: formData.reportType,
        consentChecked: true,
        accept: true,
      };

      setLoading1(true);
      setMessage1();
      setError1(false);

      const responseData = await getRequestedReport(newPayload);

      setLoading1(false);

      if (responseData?.status == 'true') {
        setMessage1(t.FormSubmitted);

        // setTimeout(() => {
        //   dispatch(portalActions.toggleRequestReportDrawer());
        // }, 2000);
      } else {
        setError1(true);
        setMessage1(t.FormFailed);
      }
    }
  };

  useEffect(()=>{
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if(message1 && userInfo){
      setFormData((prevData) => ({
        ...prevData,
        email: userInfo?.email || '',
        phone: userInfo?.mobileNumber || '',
        reportType: '',
        visitType: '',
        deliveryMethod: 'email',
        message: '',
      }));
      setTimeout(()=>setMessage1(), 3000)
    }
  },[message1])

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (userInfo) {
      setFormData((prevData) => ({
        ...prevData,
        email: userInfo?.email || '',
        phone: userInfo?.mobileNumber || '',
      }));
    }
  }, []);

  if (reportTypeLoading || profileLoading) return <Loader />;

  if (reportTypeError || profileError) {
    return <div className="p-8">{t.Something_Wrong}</div>;
  }

  const sortedReportTypeList = reportTypeList?.report_type_list?.sort(
    (a, b) => a.report_code - b.report_code
  );

  return (
    <div>
      <div className="px-8">
        <form onSubmit={handleRequestReport}>
          {/* Email */}
          {!message1 && (
          <>
          <label htmlFor="email">
            {t.EmailAddress} <br />

            <input
              id="email"
              type="email"
              name="email"
              placeholder={t.EnterYourEmailAddress}
              value={formData.email}
              onChange={handleChange}
              disabled
              className='disabled'
            />

            {!isVerified && 
              <p className="text-tertiary mt-1">
                {t.EmailNotVerified}
              </p>
            }
          </label>

          {/* Phone */}
          <label htmlFor="phone">
            {t.CellPhoneNumber}* <br />

            <div className="countrycode" dir="ltr">
              <div className="code text-secondary">({PHONE_CODE})</div>

              <input
                id="phone"
                type="number"
                name="phone"
                placeholder="5xxxxxxxx"
                value={formData.phone}
                onChange={handleChange}
                className='noArrow'
              />
            </div>

            {phoneRequire && (
              <p className="text-tertiary mt-1">
                {t.Missing_or_invalid_parameter}
              </p>
            )}
          </label>

          {/* Report Type */}
          <label htmlFor="reportType">
            {t.ChooseAReportType} <br />

            <div className="selectWithName relative">
              <select
                name="reportType"
                id="reportType"
                value={formData.reportType}
                onChange={handleChange}
              >
                <option value="">
                  {t.SelectYourReportType}
                </option>

                {sortedReportTypeList?.map((x) => {
                  const label = isRtl
                    ? x.report_description_ar
                    : x.report_description;

                  const value = x.report_code;

                  return (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  );
                })}
              </select>

              {/* <span className="selectName text-secondary">
                {t.Type}
              </span> */}
            </div>

            {/* Report Type Validation */}
            {reportTypeRequire && (
              <p className="text-tertiary mt-1">
                {t.ReportTypeFieldRequired ||
                  'Report type is required'}
              </p>
            )}
          </label>

          {/* Visit Type */}
          <label htmlFor="visitType">
            {t.SelectAVisit} <br />

            <div className="selectWithName relative">
              <select
                name="visitType"
                id="visitType"
                value={formData.visitType}
                onChange={handleChange}
              >
                <option value="">
                  {t.SelectAVisit}
                </option>

                {visitsTypeList?.episode_list?.map((x) => {
                  const label = `${x?.episode_date}-${x?.episodeType}-${
                    x?.care_provider_description ?? ''
                  }`;

                  const value = x.episode_id;

                  return (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  );
                })}
              </select>

              {/* <span className="selectName text-secondary">
                {t.Visit}
              </span> */}
            </div>

            {/* Visit Validation */}
            {visitTypeRequire && (
              <p className="text-tertiary mt-1">
                {t.VisitFieldRequired ||
                  'Visit is required'}
              </p>
            )}
          </label>

          {/* Delivery Method - Email */}
          <label className='flex items-center gap-x-1' htmlFor="reviewEmail">
            <input
              type="radio"
              name="deliveryMethod"
              id="reviewEmail"
              value="email"
              checked={formData.deliveryMethod === 'email'}
              onChange={() =>
                setFormData((prevData) => ({
                  ...prevData,
                  deliveryMethod: 'email',
                }))
              }
            />

            {t.ReceiveByEmail}
          </label>

          {/* Delivery Method - In Person */}
          <label className='flex items-center gap-x-1' htmlFor="reviewInPerson">
            <input
              type="radio"
              name="deliveryMethod"
              id="reviewInPerson"
              value="pickup"
              checked={formData.deliveryMethod === 'pickup'}
              onChange={() =>
                setFormData((prevData) => ({
                  ...prevData,
                  deliveryMethod: 'pickup',
                }))
              }
            />

            {t.ReceiveByPersonal}
          </label>

          {/* Message */}
          <label htmlFor="message">
            {t.Message}* <br />

            <textarea
              id="message"
              name="message"
              placeholder={t.TypeMessage}
              value={formData.message}
              onChange={handleChange}
              maxLength={500}
            ></textarea>

            <p className=" text-gray-500 mt-1">{formData.message.length}/500</p>

            {/* Message Validation */}
            {messageRequire && (
              <p className="text-tertiary mt-1">
                {t.MessageFieldRequired}
              </p>
            )}
          </label>

          {/* Submit Button */}
          <div className="flex justify-center mt-3">
            <button
              type="submit"
              className={`request_btn ${!isVerified && 'opacity-[0.5] cursor-not-allowed'}`}
              disabled={!isVerified || loading1}
            >
              {loading1 ? (
                <Loader size="small" roundLoader />
              ) : (
                t.Request
              )}
            </button>
          </div>
          </>)}

          {/* API Response Message */}
          {message1 && (
            <p
              className={`${
                error1 ? 'errorMsg' : 'successMsg'
              } my-2 text-center`}
            >
              <span>{message1}</span>
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
